import { capacityAtReference } from '@/versions/v1/shared/CapacityEngine';
import { CAPACITY_SEED } from '@/versions/v1/shared/capacity-seed';

const CAPACITY_CURRENT_READ = capacityAtReference(CAPACITY_SEED);

/** Current-point EBITDA per hour of mill operation, derived through the
 *  capacity model so lost and regained hours share one money basis. */
export function ebitdaPerOperatingHour(): number {
  return CAPACITY_CURRENT_READ.scenarios.find((scenario) => scenario.id === 'current')!.financials.ebitdaA / 24;
}

/** Price a proposed stop at the current EBITDA rate. The bearing inspection is
 *  additional to the Year 1 schedule, so its hours are priced; planned events
 *  already inside that schedule remain US$0 through `valueLostForEvent()`. */
export function stopValue(hours: number): number {
  return Math.round(hours * ebitdaPerOperatingHour() * 100) / 100;
}

/** The measured operating feed the capacity and maintenance pages price
 *  against — the reference read's own `measuredThroughputStph`
 *  (`rd-kpi-ore-td` ÷ 24 = 71.7 stph at the cursor). Never the typed 60 t/h
 *  Budget rate: a lost hour costs the tonnes the plant actually mills. */
export function measuredFeedStph(): number {
  return CAPACITY_CURRENT_READ.measuredThroughputStph;
}
